import { render, staticRenderFns } from "./InDmImage.vue?vue&type=template&id=3c97c2c4&scoped=true"
import script from "./InDmImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./InDmImage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InDmImage.vue?vue&type=style&index=0&id=3c97c2c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c97c2c4",
  null
  
)

export default component.exports